import SearchAdgroupPage from '@/components/google-ads/search/SearchAdgroupPage';
import { LEADS_OBJECTIVE } from './leadsObjective';

/** ADD AD GROUPS TO A LEADS CAMPAIGN — /google-ads/leads/create/adgroup */
export default function CreateLeadsAdgroup() {
  return <SearchAdgroupPage objective={LEADS_OBJECTIVE} />;
}
